import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const Node = styled.div<{ background?: string; color?: string }>`
    font-size: var(--font-size-sm);
    display: flex;
    height: 32px;
    line-height: 32px;
    align-items: center;
    justify-content: flex-start;
    border-radius: 4px;
    padding-right: 4px;
    color: ${({ color }) => color || 'var(--color-black)'};
`

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    margin-right: 4px;
`

export const Close = styled(IconFont)`
    font-size: 14px;
    margin-left: 4px;
    cursor: pointer;
`
